import { getInstance } from '../helpers';

const usePerformanceData = () => {
  const instance = getInstance();
  return instance?.getPerformanceData();
};

export default usePerformanceData;
